var _a, _b, _c, _d;
import { PlanType } from '../../enum';
import { REPORT_ROUTER_URL } from '../../router';
var DisplayMode;
(function (DisplayMode) {
  DisplayMode["All"] = "ALL";
  DisplayMode["Single"] = "SINGLE_SKILL";
  DisplayMode["Multi"] = "MULTI_SKILL";
})(DisplayMode || (DisplayMode = {}));
export var ActionType;
(function (ActionType) {
  ActionType["Export"] = "export";
  ActionType["Print"] = "print";
})(ActionType || (ActionType = {}));
export var REPORT_OPTIONS = [{
  name: 'reportControl.reportOptions.annual.name',
  nameMonthly: 'reportControl.reportOptions.annual.nameMonthly',
  nameMonthlyCustom: 'reportControl.reportOptions.annual.nameMonthlyCustom',
  id: REPORT_ROUTER_URL.Annual
}, {
  name: 'reportControl.reportOptions.period.name',
  nameMonthly: 'reportControl.reportOptions.period.nameMonthly',
  nameMonthlyCustom: 'reportControl.reportOptions.period.nameMonthlyCustom',
  id: REPORT_ROUTER_URL.Period
}, {
  name: 'reportControl.reportOptions.daily.name',
  id: REPORT_ROUTER_URL.Daily
}, {
  name: 'reportControl.reportOptions.interval.name',
  id: REPORT_ROUTER_URL.Interval
}];
export var DISPLAY_MODE_OPTIONS = [{
  name: 'reportControl.displayModeOptions.allSkills',
  id: DisplayMode.All
}, {
  name: 'reportControl.displayModeOptions.singleSkillOnly',
  id: DisplayMode.Single
}, {
  name: 'reportControl.displayModeOptions.multiSkillOnly',
  id: DisplayMode.Multi
}];
export var FILE_NAME_BY_REPORT = (_a = {}, _a[REPORT_ROUTER_URL.Annual] = (_b = {}, _b[PlanType.Weekly] = 'Summary', _b[PlanType.Monthly] = 'Annual', _b[PlanType.MonthlyCustom] = 'Summary Custom', _b), _a);
export var FILE_NAME_BY_TAB = (_c = {}, _c[REPORT_ROUTER_URL.Resourcing] = 'Resources', _c[REPORT_ROUTER_URL.Financial] = 'Financials', _c);
export var FILE_EXT = (_d = {}, _d[ActionType.Export] = 'xlsx', _d[ActionType.Print] = 'pdf', _d);